import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";

import { getUserMenuList } from "../../../application/selectors/user";
import BreadcrumbsComponent from "../../components/shared/breadcrumbs";

export const EDC_ROOT_CRUMB = { title: "شرکت های توزیع", to: "/EDC" };
export const EDC_MANAGEMENT_CRUMB = { title: "مدیریت", to: "/EDC/Management" };

const hasEdcMenu = (items) =>
  Array.isArray(items) &&
  items.some(
    (m) => String(m?.link || "").toLowerCase() === "/edc" || hasEdcMenu(m?.child)
  );

/** Falls back to fixed titles while EDC modules are inactive in MNG_ModuleLists. */
const EDCBreadcrumbs = ({ crumbs = [] }) => {
  const menuList = useSelector(getUserMenuList);
  if (hasEdcMenu(menuList)) return <BreadcrumbsComponent />;

  return (
    <Breadcrumbs separator={<NavigateBeforeIcon fontSize="small" />}>
      <Link component={RouterLink} underline="hover" color="inherit" to="/">
        داشبورد
      </Link>
      {crumbs.map((crumb, index) =>
        index === crumbs.length - 1 ? (
          <Typography key={crumb.to} color="text.primary">
            {crumb.title}
          </Typography>
        ) : (
          <Link
            key={crumb.to}
            component={RouterLink}
            underline="hover"
            color="inherit"
            to={crumb.to}
          >
            {crumb.title}
          </Link>
        )
      )}
    </Breadcrumbs>
  );
};

export default EDCBreadcrumbs;
